import { WorkOrderStatusEnum } from '@ztechapps/common.contract'

/**
 * A destructed work order is terminal — its build was already reversed, so it can never be
 * fulfilled, transitioned or re-adjusted. Shared by every server chokepoint so the
 * `status === Destructed` check isn't re-spelled per call site.
 *
 * Precedent: `libs/order/common/src/order/isOrderCancelled.ts:9`.
 */
export const isWorkOrderDestructed = (status?: WorkOrderStatusEnum): boolean =>
  status === WorkOrderStatusEnum.Destructed
